import React from 'react';
import { IconProps } from './types/Icon.type';

function Apartment48Icon(props: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66699 16.8313L16.9478 7.33325L24.6821 13.9796L32.4869 7.33325L44.667 16.8313V40.6669H28.0005H21.3334H4.66699V16.8313ZM21.3334 29.0014V32.3347H18.0006V29.0014H21.3334ZM21.3334 22.333V25.6664H18.0006V22.333H21.3334ZM28.0005 32.3347H31.3333V29.0014H28.0005V32.3347ZM28.0005 25.6664H31.3333V22.333H28.0005V25.6664ZM11.3339 22.333H14.6672V25.6664H11.3339V22.333ZM11.3339 29.0015H14.6672V32.3349H11.3339V29.0015ZM38.0002 22.333H34.6668V25.6664H38.0002V22.333ZM38.0002 29.0014H34.6668V32.3347H38.0002V29.0014Z"
        fill="#999999"
      />
    </svg>
  );
}

export default Apartment48Icon;
